import React, { Component } from 'react';
import {
  Section,
  Title,
  Body,
  Comparison,
} from './Section';

import './Landing.css';

class WhyItMatters extends Component {
  render() {
    return (
      <Section>
        <Title title="WHY" subtitle="DOES IT MATTER?" />
        <Body>
          <p>Security does not have to be an inconvenience.</p>
          <p>Convenience should not compromise security.</p>
        </Body>
        <Comparison
          headers={[ "BEFORE", "WITH" ]}
          rows={[
            [
              "Endless missed delivery slips",
              "Have your packages delivered straight to you or left by your unit door"
            ], [
              "Share entry fobs among roomates",
              "Individual passcodes for every roomate"
            ], [
              "Keep guests waiting because you missed their call",
              "Guests can directly gain access with the passcodes you give them"
            ], [
              "Take time off work to let workers in",
              "Enable passcodes for workers only when they're expected"
            ], [
              "Locked out because you forgot your entry fob",
              "Gain access to your floor even when you forgot your entry fob"
            ]
          ]}
        />
      </Section>
    );
  }
}

export default WhyItMatters


// WEBPACK FOOTER //
// ./src/entries/Static/WhyItMatters.js